// extracted by mini-css-extract-plugin
export default {"roundIcon":"MapPage_roundIcon__j3yYc"};